import {Button, Form, FormInstance, InputNumber, message, Modal, Select, Space, Table} from 'antd'
import React, {useRef, useState} from 'react'
import NavBreadcrumb from '../../../components/NavBreadcrumb'
import DigitalAssessLayout from '../components/DigitalAssessLayout'
import AxiosUtil from '../../../utils/AxiosUtil'
import MyDivTable from '../components/MyDivTable'
import styles from './taskAssign.module.less'

const crumb = [{name: '数字评价'}, {name: '任务分配'}]

export default function DigitalAssessTaskAssign() {
  const [autoForm] = Form.useForm()
  const myRef = useRef<{
    loadData: () => void
    setLoading: (is: boolean) => void
    selectedRowKeys: React.Key[]
    setSelectedRowKeys: (keys: React.Key[]) => void
    loadTotal: (callBack?: (num: number) => void) => void
    form: FormInstance<any>
  }>()
  // const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]) // table 中选中项的 id
  const [isAuto, setIsAuto] = useState(false) // 是否是自动分配任务
  const [showTaskAssign, setShowTaskAssign] = useState(false) // 显示分配任务的 Modal
  const [autoTotal, setAutoTotal] = useState(0) // 任务总条数
  const [autoAssignTotal, setAutoAssignTotal] = useState(0) // 自动分配的任务条数
  const [userList, setUserList] = useState<any[]>([]) // userList
  const [curUserId, setCurUserId] = useState(0) // 手动分配任务选中的用户 id
  const [assigning, setAssigning] = useState(false)

  /** 打开分配任务的 Modal */
  const openTaskAssign = (isAutoAssign: boolean) => {
    setIsAuto(isAutoAssign)
    if (isAutoAssign) {
      myRef.current?.setLoading(true)
      myRef.current?.loadTotal((total) => {
        setAutoTotal(total)
        setShowTaskAssign(true)
      })
    } else {
      if (!myRef.current?.selectedRowKeys.length) message.error('请至少选择一条要分配的任务 !')
      else setShowTaskAssign(true)
    }
  }
  /** 分配任务 */
  const assignTask = () => {
    if (isAuto) {
      if (autoAssignTotal === 0) message.error('您未分配任务 !')
      else {
        if (autoTotal < autoAssignTotal) message.error('自动分配的任务总数不能大于未分配的任务数 !')
        else {
          setAssigning(true)
          const taskListMap = Object.entries(autoForm.getFieldsValue())
          const taskList = taskListMap.filter((item) => item[1]).map((item) => ({userId: item[0], taskCount: item[1]}))
          const {taskTime, taskStatus, ...other} = myRef.current?.form.getFieldsValue()
          const beginDate = taskTime ? taskTime[0]?.format('YYYY-MM-DD') : undefined
          const endTime = taskTime ? taskTime[1]?.format('YYYY-MM-DD') : undefined
          const params = {beginDate, endTime, ...other}
          AxiosUtil.AxiosRequest('/api/digitalizeTask/setTask', {taskList, ...params}, (suc) => {
            if (suc) {
              message.success('任务分配完成 !')
              myRef.current?.setSelectedRowKeys([])
              hideModal()
              myRef.current?.loadData()
            }
            setAssigning(false)
          })
        }
      }
    } else {
      if (!curUserId) message.error('请选择分配任务用户 !')
      else {
        AxiosUtil.AxiosRequest('/api/digitalizeTask/setTaskByUser', {userId: curUserId, taskIdlList: myRef.current?.selectedRowKeys}, (suc) => {
          if (suc) {
            message.success('任务分配完成 !')
            myRef.current?.setSelectedRowKeys([])
            setCurUserId(0)
            hideModal()
            myRef.current?.loadData()
          }
          setAssigning(false)
        })
      }
    }
  }
  /** 隐藏 Modal */
  const hideModal = () => {
    setShowTaskAssign(false)
    isAuto && autoForm.resetFields()
    setAutoAssignTotal(0)
  }
  /** 自动分配任务 Modal 中 table 的 columns */
  const userColumns = [
    {title: '姓名', key: 'user_name', dataIndex: 'user_name'},
    {title: '登录名', key: 'login_name', dataIndex: 'login_name'},
    {
      title: '任务数',
      key: 'user_id',
      dataIndex: 'user_id',
      className: 'table-input',
      render: (user_id: string) => (
        <Form.Item name={user_id} initialValue={0} style={{margin: 0}}>
          <InputNumber
            onChange={() => {
              const numbers: number[] = Array.from(new Set(Object.values(autoForm.getFieldsValue())))
              numbers.length ? setAutoAssignTotal(numbers.reduce((total, cur) => total + cur, 0)) : setAutoAssignTotal(0)
            }}
            min={0}
            precision={0}
          />
        </Form.Item>
      ),
    },
  ]

  return (
    <DigitalAssessLayout>
      <NavBreadcrumb itemList={crumb} />
      <div id={styles.taskAssign}>
        <Space size={32} style={{marginBottom: 20}}>
          <Button type="primary" onClick={() => openTaskAssign(true)}>
            自动分配
          </Button>
          <Button type="primary" onClick={() => openTaskAssign(false)}>
            手动分配
          </Button>
        </Space>
        <MyDivTable onRef={myRef} onUserListChange={setUserList} />
        {/* 分配任务 */}
        <Modal
          title={(isAuto ? '自动' : '手动') + '分配任务'}
          visible={showTaskAssign}
          onOk={assignTask}
          onCancel={hideModal}
          centered
          confirmLoading={assigning}
          destroyOnClose
        >
          {isAuto ? (
            <div>
              共 <span className={'strong red'}>{autoTotal}</span> 条未分配任务，将按一下设置分配{' '}
              <span className={'strong red'}>{autoAssignTotal}</span> 条任务：
              <Form form={autoForm} autoComplete={'off'}>
                <Table rowKey={'user_id'} size={'small'} columns={userColumns} dataSource={userList} pagination={false} />
              </Form>
            </div>
          ) : (
            <div style={{padding: 36}}>
              您已选择 <span className={'strong red'}>{myRef.current?.selectedRowKeys.length}</span> 条任务，将所选择任务分配给：
              <Select
                style={{width: 380, margin: 10}}
                placeholder={'请选择要分配的人员'}
                options={userList.map((item: any) => ({value: item.user_id, label: `${item.user_name} (${item.login_name})`}))}
                onChange={(value: number) => setCurUserId(value)}
              />
            </div>
          )}
        </Modal>
      </div>
    </DigitalAssessLayout>
  )
}
